import React, { useState, useEffect, useCallback } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useNavigate, useLocation } from 'react-router-dom';
import LoginLogo from '../../Assets/images/Frame 39059 1.png';
import LoginImg from '../../Assets/images/Loginimage-woman-smile-happy-joy 1.png';
import GoogleLogo from '../../Assets/images/GoogleLogo.png';
import SignupBackground from '../../Assets/images/SignupBackground.png';
import Swal from 'sweetalert2';
import apiClient from '../../Api/apiClient';
import { API_BASE_URL } from '../../Api/config';
import LocationSelector from '../../Components/Location/Location';
import BusinessCategorySelector from '../../Components/CategorySelector/BusinessCategorySelector';
import SignUpAffilate from './SignUpAffilate';
import { debounce } from 'lodash';
const SignUp = ({ onSignUp }) => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  // const [ReTypepassword, setReTypepassword] = useState('');
  const [passwordReTypeVisible, setPasswordReTypeVisible] = useState(false);
  const location = useLocation();
  const { PricingBeforLogin, FromCheckoutAlert, RegiClickFromAffiliator } =
    location.state || {};
  const [userName, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [ReTypepassword, setReTypepassword] = useState('');
  const [errors, setErrors] = useState({});
  const [countryCode, setCountryCode] = useState('88'); // Set default country code
  const [passwordStrength, setPasswordStrength] = useState({
    minLength: false,
    uppercase: false,
    lowercase: false,
    number: false,
    specialChar: false,
  });
  const [selectedLocation, setSelectedLocation] = useState({
    districtId: null,
    districtName: '',
    upazilaId: null,
    upazilaName: '',
  });
  const [selectedCategory, setSelectedCategory] = useState({
    subsectorId: null,
    subsectorName: '',
  });

  const [matchedPhone, setMatchedPhone] = useState(false);
  const [matchedEmail, setMatchedEmail] = useState(false);


  const handleLocationSelect = (
    districtId,
    districtName,
    upazilaId,
    upazilaName
  ) => {
    setSelectedLocation({ districtId, districtName, upazilaId, upazilaName });
  };

  // Function to handle selected category
  const handleSelectCategory = (subsectorId, subsectorName) => {
    setSelectedCategory({ subsectorId, subsectorName });
  };

  const navigate = useNavigate();

  const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);
  const toggleReTypePasswordVisibility = () =>
    setPasswordReTypeVisible(!passwordReTypeVisible);

  const validateForm = () => {
    const newErrors = {};
    if (!userName) newErrors.userName = 'Phone is required';
    // if (!email) newErrors.userName = 'Email is required';
    if (!password) newErrors.password = 'Password is required';
    if (!ReTypepassword)
      newErrors.ReTypepassword = 'confirm Password is required';
    return newErrors;
  };

  // const [districts, setDistricts] = useState([]);
  // const [upazilas, setUpazilas] = useState([]);
  // const [selectedDistrict, setSelectedDistrict] = useState('');
  // const [selectedUpazila, setSelectedUpazila] = useState('');
  // const [categories, setCategories] = useState([]);
  // const [selectedCategory, setSelectedCategory] = useState('');

  const [activeTab, setActiveTab] = useState(
    RegiClickFromAffiliator ? 'affiliator' : 'user'
  );

  // useEffect(() => {
  //   // Fetch districts on component mount
  //   apiClient
  //     .get('/user/visitor/district', {})
  //     .then(response => {
  //       console.log('Fetched districts:', response.data.data);
  //       setDistricts(response.data.data); // Set districts in the state
  //     })
  //     .catch(error => {
  //       console.error('Error fetching districts:', error);
  //     });
  // }, []);

  // // Update upazilas when a district is selected
  // useEffect(() => {
  //   if (selectedDistrict) {
  //     const selectedDistrictData = districts.find(
  //       district => district.id === parseInt(selectedDistrict)
  //     );

  //     if (selectedDistrictData && selectedDistrictData.upazilas) {
  //       setUpazilas(selectedDistrictData.upazilas); // Set upazilas from selected district
  //     } else {
  //       setUpazilas([]); // Clear upazilas if no upazilas found
  //     }
  //   }
  // }, [selectedDistrict, districts]); // Re-run when selectedDistrict or districts change

  // // Fetch categories on component mount
  // useEffect(() => {
  //   apiClient
  //     .get('/user/visitor/sector', {})
  //     .then(response => {
  //       console.log('Fetched sector:', response.data.data);

  //       // Map through the response and extract sub_sectors
  //       const categoriesWithSubSectors = response.data.data.map(sector => ({
  //         ...sector,
  //         sub_sectors: sector.sub_sectors || [], // Ensure sub_sectors exist
  //       }));

  //       console.log(
  //         'fetch sub category from category:',
  //         categoriesWithSubSectors
  //       );
  //       setCategories(categoriesWithSubSectors);
  //     })
  //     .catch(error => {
  //       console.error('Error fetching categories:', error);
  //     });
  // }, []);

  const handleSignUp = async () => {
    const validationErrors = validateForm();

    const formData = {
      phone: `${countryCode}${userName}`,
      email: email,
      password: password,
      retype_password: ReTypepassword,
      district_id: selectedLocation.districtId,
      upazila_id: selectedLocation.upazilaId,
      // sub_sector_id: selectedCategory,
      sub_sector_id: selectedCategory.subsectorId,
    };
    // console.log('before api call', formData);

    if (Object.keys(validationErrors).length === 0) {
      try {
        const response = await apiClient.post(
          //  '/auth/user/sign-up',
          `${API_BASE_URL}/auth/user/sign-up`,
          formData
        );
        console.log('Signup successful:', response);
        const successMessage = response.data.message;
        Swal.fire({
          title: 'Success!',
          text: successMessage,
          confirmButtonText: 'Okay',
          customClass: {
            popup: 'w-72 h-auto p-3',
            title: 'text-lg',
            content: 'text-xs',
            confirmButton:
              'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
          },
        });
        // navigate to OTP page
        navigate('/otp', {
          state: {
            phone: `${countryCode}${userName}`,
            PricingBeforLogin: PricingBeforLogin,
            FromCheckoutAlert: FromCheckoutAlert,

          },
        });
      } catch (error) {
        console.error('Signup failed:', error);
        const errorMessage = error.response?.data?.message;
        // error.response?.data?.message || 'An unknown error occurred';
        Swal.fire({
          title: 'Failed!',
          text: errorMessage,
          confirmButtonText: 'Okay',
          customClass: {
            popup: 'w-72 h-auto p-3',
            title: 'text-lg',
            content: 'text-xs',
            confirmButton:
              'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
          },
        });
      }
    } else {
      setErrors(validationErrors);
    }
  };

  const handleSignUpKey = e => {
    if (e.key === 'Enter') {
      handleSignUp();
    }
  };
  // Validate Password Strength
  const handlePasswordChange = value => {
    setPassword(value);
    setPasswordStrength({
      minLength: value.length >= 8,
      uppercase: /[A-Z]/.test(value),
      lowercase: /[a-z]/.test(value),
      number: /\d/.test(value),
      specialChar: /[!@#$%^&*]/.test(value),
    });
  };



  const checkPhoneExists = async (phone) => {
    try {
      // Step 1: Search with user_type = "user"
      let queryParams = new URLSearchParams();
      if (phone) queryParams.append('phone', phone);
      queryParams.append('user_type', 'user');

      let response = await apiClient.get(
        `${API_BASE_URL}/user/visitor/users?${queryParams.toString()}`
      );

      // If data is found with user_type = "user", update states and return
      if (response.data?.data && response.data.data.length > 0) {
        const userData = response.data.data[0];
        setMatchedPhone(userData.phone === phone);
        return { phoneExists: true };
      }

      // Step 2: If no data is found with user_type = "user", search with end_user_type = "end_user"
      queryParams = new URLSearchParams();
      if (phone) queryParams.append('phone', phone);
      queryParams.append('end_user_type', 'end_user');

      response = await apiClient.get(
        `${API_BASE_URL}/user/visitor/users?${queryParams.toString()}`
      );

      // If data is found with end_user_type = "end_user", update states and return
      if (response.data?.data && response.data.data.length > 0) {
        const userData = response.data.data[0];
        setMatchedPhone(userData.phone === phone);
        return { phoneExists: true };
      }

      // If no data is found, update states and return
      setMatchedPhone(false);
      return { phoneExists: false };

    } catch (error) {
      console.error('Error checking phone number:', error);
      setMatchedPhone(false);
      return { phoneExists: false };
    }
  };

  const checkEmailExists = async (email) => {
    try {
      // Step 1: Search with user_type = "user"
      let queryParams = new URLSearchParams();
      if (email) queryParams.append('key', email);
      queryParams.append('user_type', 'user');

      let response = await apiClient.get(
        `${API_BASE_URL}/user/visitor/users?${queryParams.toString()}`
      );

      // If data is found with user_type = "user", update states and return
      if (response.data?.data && response.data.data.length > 0) {
        const userData = response.data.data[0];
        setMatchedEmail(userData.email === email);
        return { emailExists: true };
      }

      // Step 2: If no data is found with user_type = "user", search with end_user_type = "end_user"
      queryParams = new URLSearchParams();
      if (email) queryParams.append('key', email);
      queryParams.append('end_user_type', 'end_user');

      response = await apiClient.get(
        `${API_BASE_URL}/user/visitor/users?${queryParams.toString()}`
      );

      // If data is found with end_user_type = "end_user", update states and return
      if (response.data?.data && response.data.data.length > 0) {
        const userData = response.data.data[0];
        setMatchedEmail(userData.email === email);
        return { emailExists: true };
      }

      // If no data is found, update states and return
      setMatchedEmail(false);
      return { emailExists: false };

    } catch (error) {
      console.error('Error checking email:', error);
      setMatchedEmail(false);
      return { emailExists: false };
    }
  };


  const debouncedCheckUserDetails = useCallback(
    debounce(async (username, email) => {
      if (username || email) {
        const phoneNumber = `${countryCode}${username}`;

        // Check if phone number exists
        const { phoneExists } = await checkPhoneExists(phoneNumber);

        // Check if email exists
        const { emailExists } = await checkEmailExists(email);

        // Update error states based on the results
        if (phoneExists) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            userName: 'This phone number is already registered.',
          }));
        } else if (emailExists) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            email: 'This email is already registered.',
          }));
        } else {
          setErrors((prevErrors) => ({
            ...prevErrors,
            userName: '',
            email: '',
          }));
        }
      }
    }, 500), // 500ms delay
    [countryCode]
  );


  // useEffect to trigger the debounced function
  useEffect(() => {
    debouncedCheckUserDetails(userName, email);
  }, [userName, email, debouncedCheckUserDetails]);


  const isFormValid = userName && password && ReTypepassword;
  const isButtonDisabled = matchedPhone || matchedEmail || !isFormValid;


  return (
    <div className="mt-24 md:mt-32 lg:mt-32">
      <div className="py-4 text-center">
        <h1 className="font-bold md:text-xl text-lg text-gray-700">
          Join with us
        </h1>
        <p className="text-sm mb-2">as</p>
        <div className="flex justify-center space-x-0 md:text-sm 2xl:text-lg text-xs">
          <button
            className={`px-0 w-24 md:py-1 py-1.5 border-r rounded-l-md border-gray-300 ${activeTab === 'user'
              ? 'bg-DefaultColor text-white'
              : 'bg-gray-200'
              }`}
            onClick={() => setActiveTab('user')}
          >
            User
          </button>
          <button
            className={`px-0 w-24 md:py-1 py-1.5 rounded-r-md border-r border-gray-300 ${activeTab === 'affiliator'
              ? 'bg-DefaultColor text-white'
              : 'bg-gray-200'
              }`}
            onClick={() => setActiveTab('affiliator')}
          >
            Affiliator
          </button>
        </div>
      </div>

      {activeTab === 'user' && (
        <div
          className="flex items-center bg-center object-cover justify-center px-4 py-4 "
          style={{ backgroundImage: `url(${SignupBackground})` }}
        >
          <div className="flex flex-col lg:flex-row  overflow-hidden max-w-5xl w-full rounded-lg border">
            {/* Left Section */}
            <div className="lg:w-1/2 w-full md:p-6 md:pt-0 p-0 flex flex-col items-center justify-center">
              <img src={LoginLogo} alt="TenderWise Logo" className="h-16" />
              <h1 className="text-sm text-gray-600 text-center mb-2">
                Register to Publish and Manage Your Tender Submissions
              </h1>
              <img
                src={LoginImg}
                alt="Illustration"
                className="md:mt-0 w-72 h-60 max-w-xs lg:max-w-sm md:block hidden"
              />
            </div>

            {/* Right Section */}
            <div className="lg:w-1/2 w-full  md:p-8 p-2 ">
              <h2 className="md:text-xl text-lg font-semibold text-gray-800 text-center">
                Create an account
              </h2>
              <p className="text-sm text-center text-gray-600 mb-4">
                Already have an account?{' '}
                <button
                  onClick={() => navigate('/login')}
                  className="font-semibold bg-DefaultColor text-white hover:underline  hover:bg-DefaultHoverColor  px-2 py-0.5 rounded-md transition-all duration-300 ease-in-out transform hover:scale-105 text-xs"
                >
                  Log In
                </button>
              </p>
              {/* Form */}
              <div className="space-y-2 mt-2">
                {/* username*/}
                <div className="flex space-x-1">
                  <select
                    className="border text-xs border-gray-300 rounded-md py-2 px-1 w-24"
                    value={countryCode}
                    onChange={e => setCountryCode(e.target.value)}
                  >
                    <option value="88">+88(Ban)</option>
                    <option value="1">+1(USA/Canada)</option>
                    <option value="44">+44(UK)</option>
                    <option value="91">+91(India)</option>
                    <option value="61">+61(Aust)</option>
                    <option value="33">+33(France)</option>
                    <option value="49">+49(Germany)</option>
                    <option value="39">+39(Italy)</option>
                    <option value="81">+81(Japan)</option>
                    <option value="7">+7(Russia)</option>
                    <option value="86">+86(China)</option>
                    <option value="34">+34(Spain)</option>
                    <option value="55">+55(Brazil)</option>
                    <option value="27">+27(SA)</option>
                    <option value="52">+52(Mexico)</option>
                    <option value="20">+20(Egypt)</option>
                    <option value="45">+45(Denmark)</option>
                    <option value="31">+31(Netherlands)</option>
                    <option value="90">+90(Turkey)</option>
                    <option value="63">+63(Philippines)</option>
                    <option value="66">+66(Thailand)</option>
                    <option value="32">+32(Belgium)</option>
                    <option value="56">+56(Chile)</option>
                    <option value="46">+46(Sweden)</option>
                    <option value="351">+351(Portugal)</option>
                    <option value="965">+965(Kuwait)</option>
                    <option value="971">+971(UAE)</option>
                    <option value="30">+30(Greece)</option>
                    <option value="972">+972(Israel)</option>
                    <option value="964">+964(Iraq)</option>
                    <option value="256">+256(Uganda)</option>
                  </select>
                  <input
                    type="text"
                    placeholder="Enter Phone Number"
                    className="border text-xs border-gray-300 rounded-md py-2 px-2 w-full"
                    value={userName}
                    onChange={e => setUsername(e.target.value)}
                    onKeyDown={handleSignUpKey}
                  />
                </div>
                {errors.userName && (
                  <p className="text-red-500 text-xs mb-0 -mt-2">
                    {errors.userName}
                  </p>
                )}

                {/* {matchedPhone && (
                  <p className="text-red-500 text-xs mb-0 -mt-2">
                    This phone number already exists. Please give another one
                  </p>
                )} */}

                {/* Email */}
                <div>
                  <input
                    type="email"
                    id="email"
                    placeholder="Enter your Email"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 text-xs focus:ring-blue-500 focus:border-blue-500"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    onKeyDown={handleSignUpKey}
                  />

                  {matchedEmail && (
                    <p className="text-red-500 text-xs mb-0 mt-2">
                      This Email already exists. Please give another one
                    </p>
                  )}

                </div>

                {/* Password */}
                <div>
                  <div className="relative">
                    <input
                      type={passwordVisible ? 'text' : 'password'}
                      id="password"
                      placeholder=" New password"
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 text-xs focus:ring-blue-500 focus:border-blue-500"
                      value={password}
                      onChange={e => handlePasswordChange(e.target.value)}
                    />
                    <button
                      type="button"
                      className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500"
                      onClick={togglePasswordVisibility}
                    >
                      {passwordVisible ? <FaEye /> : <FaEyeSlash />}
                    </button>
                  </div>
                  {/* Password Strength Checklist */}
                  {password && (
                    <div className="mt-2 text-xs text-gray-600 space-y-1">
                      <p
                        className={
                          passwordStrength.minLength
                            ? 'text-green-600'
                            : 'text-red-600'
                        }
                      >
                        {passwordStrength.minLength
                          ? '✔ Use at least 8 characters'
                          : '✘ Use at least 8 characters'}
                      </p>
                      <p
                        className={
                          passwordStrength.uppercase
                            ? 'text-green-600'
                            : 'text-red-600'
                        }
                      >
                        {passwordStrength.uppercase
                          ? '✔ Add at least one uppercase letter'
                          : '✘ Add at least one uppercase letter'}
                      </p>
                      <p
                        className={
                          passwordStrength.lowercase
                            ? 'text-green-600'
                            : 'text-red-600'
                        }
                      >
                        {passwordStrength.lowercase
                          ? '✔ Add at least one lowercase letter'
                          : '✘ Add at least one lowercase letter'}
                      </p>
                      <p
                        className={
                          passwordStrength.number
                            ? 'text-green-600'
                            : 'text-red-600'
                        }
                      >
                        {passwordStrength.number
                          ? '✔ Include at least one number'
                          : '✘ Include at least one number'}
                      </p>
                      <p
                        className={
                          passwordStrength.specialChar
                            ? 'text-green-600'
                            : 'text-red-600'
                        }
                      >
                        {passwordStrength.specialChar
                          ? '✔ Include at least one special character'
                          : '✘ Include at least one special character'}
                      </p>
                    </div>
                  )}
                </div>
                {errors.password && (
                  <p className="text-red-500 text-xs mb-0 -mt-2">
                    {errors.password}
                  </p>
                )}

                {/* Re type password */}
                <div className="relative">
                  <input
                    type={passwordReTypeVisible ? 'text' : 'password'}
                    placeholder="Confirm Password"
                    className="border  border-gray-300 rounded-md py-2 px-4 w-full text-xs"
                    value={ReTypepassword}
                    onChange={e => setReTypepassword(e.target.value)}
                    onKeyDown={handleSignUpKey}
                  />
                  <button
                    type="button"
                    onClick={toggleReTypePasswordVisibility}
                    className="absolute inset-y-0 right-0 flex items-center px-3 focus:outline-none text-gray-500"
                  >
                    {passwordReTypeVisible ? <FaEye /> : <FaEyeSlash />}
                  </button>
                </div>
                {errors.ReTypepassword && (
                  <p className="text-red-500 text-xs mb-0 -mt-2">
                    {errors.ReTypepassword}
                  </p>
                )}

                {/* Dropdowns */}
                <div className="">
                  <label className="block text-xs font-bold mb-3 mt-4">
                    Choose your Tender Category
                  </label>


                  <BusinessCategorySelector
                    onSelectCategory={handleSelectCategory}
                  />
                  <div className="flex flex-row md:flex-row md:items-center items-center md:gap-2 text-xs md:mb-4 mb-4">
                    <label className=" w-1/3 ">
                      Location
                    </label>
                    <div className="flex items-center gap-2  w-full text-xs">
                      <LocationSelector
                        onSelectLocation={handleLocationSelect}
                      />
                    </div>
                  </div>
                </div>
                <div></div>

                {/* Create Account Button */}
                <button
                  type="submit"
                  onClick={handleSignUp}
                  className={`w-full bg-EntryBG text-white py-1.5 px-6  mb-1 mt-2 rounded-md ${isButtonDisabled ? 'bg-gray-300 ' : 'bg-blue-500 hover:bg-btnHover cursor-pointer'}`}
                  disabled={isButtonDisabled}
                >
                  Create an Account
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {activeTab === 'affiliator' && <SignUpAffilate></SignUpAffilate>}
    </div>
  );
};

export default SignUp;

// import React, { useState, useEffect } from 'react';
// import { FaEye, FaEyeSlash } from 'react-icons/fa';
// import { useNavigate, useLocation } from 'react-router-dom';
// import LoginLogo from '../../Assets/images/Frame 39059 1.png';
// import LoginImg from '../../Assets/images/Loginimage-woman-smile-happy-joy 1.png';
// import GoogleLogo from '../../Assets/images/GoogleLogo.png';
// import SignupBackground from '../../Assets/images/SignupBackground.png';
// import Swal from 'sweetalert2';
// import apiClient from '../../Api/apiClient';
// import { API_BASE_URL } from '../../Api/config';
// const SignUp = ({ onSignUp }) => {
//   const [passwordVisible, setPasswordVisible] = useState(false);
//   const [password, setPassword] = useState('');
//   const [confirmPassword, setConfirmPassword] = useState('');
//   // const [ReTypepassword, setReTypepassword] = useState('');
//   const [passwordReTypeVisible, setPasswordReTypeVisible] = useState(false);
//   const location = useLocation();
//   const { PricingBeforLogin } = location.state || {};
//   const [userName, setUsername] = useState('');
//   const [ReTypepassword, setReTypepassword] = useState('');
//   const [errors, setErrors] = useState({});
//   const [countryCode, setCountryCode] = useState('88'); // Set default country code
//   const [passwordStrength, setPasswordStrength] = useState({
//     minLength: false,
//     uppercase: false,
//     lowercase: false,
//     number: false,
//     specialChar: false,
//   });

//   const navigate = useNavigate();

//   const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);
//   const toggleReTypePasswordVisibility = () =>
//     setPasswordReTypeVisible(!passwordReTypeVisible);

//   const validateForm = () => {
//     const newErrors = {};
//     if (!userName) newErrors.userName = 'Username is required';
//     if (!password) newErrors.password = 'Password is required';
//     if (!ReTypepassword)
//       newErrors.ReTypepassword = 'confirm Password is required';
//     return newErrors;
//   };

//   const [districts, setDistricts] = useState([]);
//   const [upazilas, setUpazilas] = useState([]);
//   const [selectedDistrict, setSelectedDistrict] = useState('');
//   const [selectedUpazila, setSelectedUpazila] = useState('');
//   const [categories, setCategories] = useState([]);
//   const [selectedCategory, setSelectedCategory] = useState('');

//   useEffect(() => {
//     // Fetch districts on component mount
//     apiClient
//       .get('/user/visitor/district', {})
//       .then(response => {
//         console.log('Fetched districts:', response.data.data);
//         setDistricts(response.data.data); // Set districts in the state
//       })
//       .catch(error => {
//         console.error('Error fetching districts:', error);
//       });
//   }, []);

//   // Update upazilas when a district is selected
//   useEffect(() => {
//     if (selectedDistrict) {
//       const selectedDistrictData = districts.find(
//         district => district.id === parseInt(selectedDistrict)
//       );

//       if (selectedDistrictData && selectedDistrictData.upazilas) {
//         setUpazilas(selectedDistrictData.upazilas); // Set upazilas from selected district
//       } else {
//         setUpazilas([]); // Clear upazilas if no upazilas found
//       }
//     }
//   }, [selectedDistrict, districts]); // Re-run when selectedDistrict or districts change

//   // Fetch categories on component mount
//   useEffect(() => {
//     apiClient
//       .get('/user/visitor/sector', {})
//       .then(response => {
//         console.log('Fetched sector:', response.data.data);

//         // Map through the response and extract sub_sectors
//         const categoriesWithSubSectors = response.data.data.map(sector => ({
//           ...sector,
//           sub_sectors: sector.sub_sectors || [], // Ensure sub_sectors exist
//         }));

//         console.log(
//           'fetch sub category from category:',
//           categoriesWithSubSectors
//         );
//         setCategories(categoriesWithSubSectors);
//       })
//       .catch(error => {
//         console.error('Error fetching categories:', error);
//       });
//   }, []);

//   const handleSignUp = async () => {
//     const validationErrors = validateForm();

//     const formData = {
//       phone: `${countryCode}${userName}`,
//       password: password,
//       retype_password: ReTypepassword,
//       district_id: selectedDistrict,
//       upazila_id: selectedUpazila,
//       sub_sector_id: selectedCategory,
//     };
//     console.log('before api call', formData);

//     if (Object.keys(validationErrors).length === 0) {
//       try {
//         const response = await apiClient.post(
//           //  '/auth/user/sign-up',
//           `${API_BASE_URL}/auth/user/sign-up`,
//           // formData
//           {
//             phone: '8801996105020',
//             password: 'Iqbal@65',
//             retype_password: 'Iqbal@65',
//             district_id: 54,
//             upazila_id: 53,
//             sub_sector_id: 51,
//           }
//         );
//         console.log('Signup successful:', response);
//         const successMessage = response.data.message;
//         Swal.fire({
//           title: 'Success!',
//           text: successMessage,
//           confirmButtonText: 'Okay',
//           customClass: {
//             popup: 'w-72 h-auto p-3',
//             title: 'text-lg',
//             content: 'text-xs',
//             confirmButton:
//               'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
//           },
//         });
//         // navigate to OTP page
//         navigate('/otp', {
//           state: {
//             phone: `${countryCode}${userName}`,
//             PricingBeforLogin: PricingBeforLogin,
//           },
//         });
//       } catch (error) {
//         console.error('Signup failed:', error);
//         const errorMessage =
//           error.response?.data?.message || 'An unknown error occurred';
//         Swal.fire({
//           title: 'Failed!',
//           text: errorMessage,
//           confirmButtonText: 'Okay',
//           customClass: {
//             popup: 'w-72 h-auto p-3',
//             title: 'text-lg',
//             content: 'text-xs',
//             confirmButton:
//               'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
//           },
//         });
//       }
//     } else {
//       setErrors(validationErrors);
//     }
//   };

//   const handleSignUpKey = e => {
//     if (e.key === 'Enter') {
//       handleSignUp();
//     }
//   };
//   // Validate Password Strength
//   const handlePasswordChange = value => {
//     setPassword(value);
//     setPasswordStrength({
//       minLength: value.length >= 8,
//       uppercase: /[A-Z]/.test(value),
//       lowercase: /[a-z]/.test(value),
//       number: /\d/.test(value),
//       specialChar: /[!@#$%^&*]/.test(value),
//     });
//   };

//   return (
//     <div className="flex bg-EntryBG items-center justify-center min-h-screen md:py-16 py-24 md:mt-10 mt-16 px-2 ">
//       <div className="bg-white md:p-10 p-6  items-center justify-center flex flex-col lg:flex-row gap-10 shadow-xl rounded-xl">
//         {/* left section */}
//         <div>
//           <img
//             src={LoginLogo}
//             alt="LoginLogo"
//             className=" h-10 lg:h-16 mb-0 md:pl-8 lg:mb-0"
//           />
//           <img src={LoginImg} alt="LoginImg" className="md:h-40 h-32 " />
//         </div>

//         {/* right section */}
//         <div className="">
//           <h2 className="text-lg text-center lg:text-xl font-semibold md:-mt-0 -mt-6 mb-1">
//             Create an Account
//           </h2>
//           <p className="mb-0 text-xs text-center ">
//             Allready have an account?
//             <button
//               // onClick={handleLoginClick}
//               className="bg-headerBtn p-1 rounded-md text-white hover:bg-btnHover ml-2"
//             >
//               Login
//             </button>
//           </p>
//           <div className="w-[250px] md:w-[300px] space-y-2 mt-2">
//             {/* Input Fields */}
//             <div className="flex flex-col space-y-2">
//               <div className="flex space-x-1">
//                 <select
//                   className="border text-xs border-gray-300 rounded-md py-2 px-1 w-24"
//                   value={countryCode}
//                   onChange={e => setCountryCode(e.target.value)}
//                 >
//                   <option value="88">+88(Ban)</option>
//                   <option value="1">+1(USA/Canada)</option>
//                   <option value="44">+44(UK)</option>
//                   <option value="91">+91(India)</option>
//                   <option value="61">+61(Aust)</option>
//                   <option value="33">+33(France)</option>
//                   <option value="49">+49(Germany)</option>
//                   <option value="39">+39(Italy)</option>
//                   <option value="81">+81(Japan)</option>
//                   <option value="7">+7(Russia)</option>
//                   <option value="86">+86(China)</option>
//                   <option value="34">+34(Spain)</option>
//                   <option value="55">+55(Brazil)</option>
//                   <option value="27">+27(SA)</option>
//                   <option value="52">+52(Mexico)</option>
//                   <option value="20">+20(Egypt)</option>
//                   <option value="45">+45(Denmark)</option>
//                   <option value="31">+31(Netherlands)</option>
//                   <option value="90">+90(Turkey)</option>
//                   <option value="63">+63(Philippines)</option>
//                   <option value="66">+66(Thailand)</option>
//                   <option value="32">+32(Belgium)</option>
//                   <option value="56">+56(Chile)</option>
//                   <option value="46">+46(Sweden)</option>
//                   <option value="351">+351(Portugal)</option>
//                   <option value="965">+965(Kuwait)</option>
//                   <option value="971">+971(UAE)</option>
//                   <option value="30">+30(Greece)</option>
//                   <option value="972">+972(Israel)</option>
//                   <option value="964">+964(Iraq)</option>
//                   <option value="256">+256(Uganda)</option>
//                 </select>
//                 <input
//                   type="text"
//                   placeholder="Enter Phone Number"
//                   className="border text-xs border-gray-300 rounded-md py-2 px-2 w-full"
//                   value={userName}
//                   onChange={e => setUsername(e.target.value)}
//                   onKeyDown={handleSignUpKey}
//                 />
//               </div>
//               {errors.userName && (
//                 <p className="text-red-500 text-xs mb-0 -mt-2">
//                   {errors.userName}
//                 </p>
//               )}

//               <div className="relative w-[250px] md:w-[300px]">
//                 <input
//                   type={passwordVisible ? 'text' : 'password'}
//                   placeholder="Create Password"
//                   className="border text-xs border-gray-300 rounded-md py-2 px-4 w-full"
//                   value={password}
//                   onChange={e => setPassword(e.target.value)}
//                   onKeyDown={handleSignUpKey}
//                 />
//                 <button
//                   type="button"
//                   onClick={togglePasswordVisibility}
//                   className="absolute inset-y-0 right-0 flex items-center px-3 focus:outline-none"
//                 >
//                   {passwordVisible ? <FaEyeSlash /> : <FaEye />}
//                   <span className="ml-1 text-xs">
//                     {passwordVisible ? 'Hide' : 'Show'}
//                   </span>
//                 </button>
//               </div>
//               {errors.password && (
//                 <p className="text-red-500 text-xs mb-0 -mt-2">
//                   {errors.password}
//                 </p>
//               )}

//               {/* Re type password */}
//               <div className="relative w-[250px] md:w-[300px]">
//                 <input
//                   // type="password"
//                   type={passwordReTypeVisible ? 'text' : 'password'}
//                   placeholder="Confirm Password"
//                   className="border text-xs border-gray-300 rounded-md py-2 px-4 w-full"
//                   value={ReTypepassword}
//                   onChange={e => setReTypepassword(e.target.value)}
//                   onKeyDown={handleSignUpKey}
//                 />
//                 <button
//                   type="button"
//                   onClick={toggleReTypePasswordVisibility}
//                   className="absolute inset-y-0 right-0 flex items-center px-3 focus:outline-none"
//                 >
//                   {passwordReTypeVisible ? <FaEyeSlash /> : <FaEye />}
//                   <span className="ml-1 text-xs">
//                     {passwordReTypeVisible ? 'Hide' : 'Show'}
//                   </span>
//                 </button>
//               </div>
//               {errors.ReTypepassword && (
//                 <p className="text-red-500 text-xs mb-0 -mt-2">
//                   {errors.ReTypepassword}
//                 </p>
//               )}
//             </div>
//             {/* Dropdowns */}
//             <div>
//               <label className="block text-sm font-bold mb-4">
//                 Choose your Tender Category
//               </label>
//               <div className="flex  items-center md:gap-2 text-xs ">
//                 <label className="w-1/3">
//                   Select Your Location <span className="text-red-600">*</span>
//                 </label>
//                 <div className="flex items-center gap-2 w-4/6">
//                   <select
//                     value={selectedDistrict}
//                     onChange={e => setSelectedDistrict(e.target.value)}
//                     className="border rounded-md p-2 w-1/2"
//                   >
//                     <option value="">District</option>
//                     {districts.map(district => (
//                       <option key={district.id} value={district.id}>
//                         {district.name}
//                       </option>
//                     ))}
//                   </select>
//                   <select
//                     value={selectedUpazila}
//                     onChange={e => setSelectedUpazila(e.target.value)}
//                     disabled={!upazilas.length}
//                     className="border rounded-md p-2 w-1/2"
//                   >
//                     <option value="">Upazila</option>
//                     {upazilas.map(upazila => (
//                       <option key={upazila.id} value={upazila.id}>
//                         {upazila.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//             </div>
//             <div>
//               <div className="flex items-center gap-2 text-xs ">
//                 <label className="w-1/2">Select your Business Category</label>
//                 <select
//                   className="w-4/6 border border-gray-300 rounded-md py-2 px-3 text-sm"
//                   value={selectedCategory}
//                   onChange={e => setSelectedCategory(e.target.value)}
//                 >
//                   <option value="">Select Category</option>
//                   {categories.map(category => (
//                     <option key={category.id} value={category.id}>
//                       {category.name}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>
//           </div>

//           {/* Create Account Button */}
//           <button
//             onClick={handleSignUp}
//             className="w-full bg-EntryBG text-white py-2 px-6 hover:bg-btnHover mb-1 mt-2 rounded-2xl"
//           >
//             Create an Account
//           </button>

//           {/* <p className="pb-1 text-center text-xs">
//               --------------------OR--------------------
//             </p> */}
//           {/* Google Sign-In Button */}
//           {/* // onClick={handleGoogleSignIn} */}
//           {/* <button
//               className="w-full border border-gray-300 py-2 px-6 flex items-center justify-center mb-4 rounded-2xl hover:bg-black hover:text-white"
//             >
//               <img
//                 src={GoogleLogo}
//                 alt="Google Logo"
//                 className="w-5 h-5 mr-2"
//               />
//               <span className="text-sm">Sign up with Google</span>
//             </button> */}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SignUp;
